<template>
  <div class="overview-index">
    <div class="d-flex align-items-center justify-content-end mb-2" v-if="showBillShared">
      <!-- storeSetDisabled 当页面处于详情页时，不设置到vuex中，仅当前页面修改生效 -->
      <div slot="res-status-tab">
        <bill-config :billShared.sync="currentBillShared" :projectShared.sync="currentProjectShared" :currency.sync="currentCurrency" :projectSharedShow="projectSharedShow" storeSetDisabled />
      </div>
    </div>
    <div class="d-flex mb-2 justify-content-between" :style="dateStyle" v-if="!isTemplate || isTemplateEdit">
      <!-- 过滤 -->
      <div class="d-flex">
        <date-time
          v-if="!(defaultDate && defaultDate.month) && !isTemplate"
          :defaultTime="defaultTime"
          :defaultDateMode="dateMode"
          :dateMode.sync="dateMode"
          :dataType.sync="dataType"
          :getParams.sync="dateTime"
          :supportDatatype="true"
          canSelectTodayAfter
          showStartMonthTip
          paramTimeFormatter="YYYY-MM-DDTZ" />
        <fixed-label-filter :class="isTemplateEdit ? 'ml-0' : 'ml-2'" :label="$t('bill.group')">
          <a-select v-model="groupTab" style="min-width:120px">
            <a-select-option v-for="(item,index) in groupTabOpts" :key="index" :value="item.key">{{item.label}}</a-select-option>
          </a-select>
        </fixed-label-filter>
        <fixed-label-filter v-if="groupTab === 'resource'" class="ml-2" :label="$t('bill.text_73')">
          <base-select
            resource="bill_conditions"
            v-model="resType"
            :params="resTypeParams"
            filterable
            :mapper="mapperResData"
            id-key="item_id"
            name-key="item_name"
            version="v1"
            :isDefaultSelect="true"
            :select-props="{ placeholder: $t('bill.choose_res_tips'), allowClear: true }" />
        </fixed-label-filter>
        <fixed-label-filter v-if="groupTab === 'project' && !defaultDomainId && l3PermissionEnable && !isDomainMode" class="ml-2" :label="$t('bill.text_76')">
          <base-select
            resource="bill_conditions"
            v-model="domainId"
            :params="domainParams"
            filterable
            :mapper="domainMapper"
            id-key="item_id"
            name-key="item_name"
            version="v1"
            :isDefaultSelect="true"
            :select-props="{ placeholder: $t('common_606'), allowClear: true }"
            @update:item="domainUpdate" />
        </fixed-label-filter>
        <fixed-label-filter v-if="groupTab === 'tag'" class="ml-2" :label="$t('bill.tag_key')">
          <base-select
            resource="res_tag_details"
            v-model="tagKey"
            :params="tagParams"
            filterable
            version="v1"
            minWidth="140px"
            :mapper="tagMapper"
            :isDefaultSelect="true"
            :select-props="{ placeholder: $t('common_605') }" />
        </fixed-label-filter>
        <fixed-label-filter v-if="groupTab === 'instance_tag'" class="ml-2" :label="$t('bill.tag_key')">
          <base-select
            resource="instance_tag_details"
            v-model="instanceTagKey"
            :params="instanceTagParams"
            filterable
            version="v1"
            minWidth="140px"
            :mapper="tagMapper"
            :isDefaultSelect="true"
            :select-props="{ placeholder: $t('common_605') }" />
        </fixed-label-filter>
        <fixed-label-filter v-if="groupTab === 'project_tag'" class="ml-2" :label="$t('bill.tag_key')">
          <base-select
            resource="project_tag_details"
            v-model="projectTagKey"
            :params="projectTagParams"
            filterable
            version="v1"
            minWidth="140px"
            :mapper="tagMapper"
            :isDefaultSelect="true"
            :select-props="{ placeholder: $t('common_605') }"
            @change="tagChange" />
        </fixed-label-filter>
        <fixed-label-filter v-if="groupTab === 'dimension'" class="ml-2" :label="$t('bill.text_297')">
          <base-select
            resource="billsdimensions"
            v-model="dimensionId"
            :params="dimensionParams"
            :needParams="true"
            filterable
            version="v1"
            :select-props="{ placeholder: $t('bill.text_302'), allowClear: false }"
            :mapper="dimensionMapper"
            :isDefaultSelect="true"
            @update:item="dimensionChange" />
        </fixed-label-filter>
      </div>
      <!-- 导出 -->
      <div class="d-flex" v-if="!isTemplateEdit">
        <a-tooltip :title="$t('common.export_excel')">
          <a-button class="mr-2" @click="exportExcel"><icon type="excel" /></a-button>
        </a-tooltip>
        <a-tooltip :title="$t('common.export_pdf')">
          <a-button @click="exportPdf"><icon type="pdf" /></a-button>
        </a-tooltip>
      </div>
    </div>
    <div id="overview-target">
      <!-- isTemplate 时：第一行两个 money-card 左右布局 -->
      <a-row v-if="isTemplate && showOverview" :gutter="12">
        <a-col :span="12">
          <money-card
            :isTemplate="isTemplate"
            :money="balance.month_fee"
            height="122px"
            :btnTitle="$t('bill.text_94')"
            @btnClick="setDayWarning"
            :currencyCn="currencyCn"
            :currencySign="currencySign"
            :increase="balance.increase"
            :showIncrease="this.dateMode === 'month' || this.dateMode === 'last_month'"
            @increaseClick="goAnalysis">
            <div slot="title">
              <span>
                {{moneyCardTitle}}
              </span>
              <help-tooltip name="billNegativeNumberReson" />
            </div>
          </money-card>
        </a-col>
        <a-col :span="12">
          <money-card
            :money="balance.year_fee"
            :isTemplate="isTemplate"
            height="122px"
            :btnTitle="$t('bill.text_96')"
            @btnClick="setMonthWarning"
            :currencyCn="currencyCn"
            :currencySign="currencySign">
            <div slot="title">
              <span>
                {{yearFeeTitle}}
              </span>
              <!-- <help-tooltip name="billCurrentYearFee" /> -->
            </div>
          </money-card>
        </a-col>
      </a-row>
      <!-- 主布局行 -->
      <a-row :gutter="12">
        <!-- 非 isTemplate 时：左侧 money-card 列 -->
        <a-col v-if="!isTemplate && showOverview" :span="8">
          <money-card
            class="mb-2"
            :money="balance.month_fee"
            height="122px"
            :btnTitle="$t('bill.text_94')"
            @btnClick="setDayWarning"
            :currencyCn="currencyCn"
            :currencySign="currencySign"
            :increase="balance.increase"
            :showIncrease="this.dateMode === 'month' || this.dateMode === 'last_month'"
            @increaseClick="goAnalysis">
            <div slot="title">
              <span>
                {{moneyCardTitle}}
              </span>
              <help-tooltip name="billNegativeNumberReson" />
            </div>
          </money-card>
          <money-card
            :money="balance.year_fee"
            height="122px"
            :btnTitle="$t('bill.text_96')"
            @btnClick="setMonthWarning"
            :currencyCn="currencyCn"
            :currencySign="currencySign">
            <div slot="title">
              <span>
                {{yearFeeTitle}}
              </span>
            </div>
          </money-card>
        </a-col>
        <!-- 预测图表 -->
        <a-col :span="isTemplate ? 24 : (showOverview ? 16 : 24)">
          <bill-predict2
            height="205px"
            :isTemplate="isTemplate"
            :header="costHeader"
            :splitLineShow="true"
            :dateMode="dateMode"
            :dataType="dataType"
            :categoryArr="categoryArr"
            :seriesArr="predictSeriesArr"
            :loading="loading"
            :currencySign="currencySign"
            :chartColors="colors"
            :showLegend="true"
            :showToolbox="true"
            :getNameI18n="getNameI18n"
            :groupType="groupTab"
            @selectedChange="legendselectchanged" />
        </a-col>
      </a-row>
      <!-- 图表 -->
      <bill-card class="mt-2">
        <pie-list
          id="bill-controls-platform"
          :dataList="pieDataList"
          :currencySign="currencySign"
          :list-title="pieListTitle"
          :subtitle="$t('bill.text_62')"
          :topLimit="topLimit"
          :isTop10="isTop10"
          :chartColors="colors"
          :groupTab="groupTab"
          :hiddenLegends="hiddenLegends"
          @topLimitChange="topLimitChange" />
      </bill-card>
    </div>
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapState, mapGetters } from 'vuex'
import XLSX from 'xlsx'
import { TIME_SIZE } from '@Bill/constants'
// import { mergePredictData } from '@Bill/utils'
import MoneyCard from '@Bill/sections/MoneyCard'
import BillPredict2 from '@Bill/sections/BillPredict2'
import currencyRequest from '@Bill/mixins/currencyRequest'
import shareMixin from '@Bill/mixins/share'
import currencyMixin from '@Bill/mixins/currency'
import BillCard from '@Bill/components/BillCard'
import PieList from '@Bill/sections/PieList'
import BillConfig from '@Bill/sections/BillConfig'
import { arrayToObj, uuid } from '@/utils/utils'
import { PROVIDER_MAP } from '@/constants'
import WindowsMixin from '@/mixins/windows'
import { getPdf } from '@/utils/echart'
import { addDataToSheetAfterFormat } from '@/utils/xlsx'
import { numerify } from '@/filters'
import { getBrandName } from '@/utils/common/hypervisor'
import { getBillResourceTypeLabel } from '@Bill/utils'
import { GROUP_TABS } from '../constants'

export default {
  name: 'OverviewIndex',
  components: {
    MoneyCard,
    BillPredict2,
    BillCard,
    PieList,
    BillConfig,
  },
  mixins: [WindowsMixin, currencyRequest, shareMixin, currencyMixin],
  props: {
    cloudEnv: String,
    isTemplate: Boolean, // 是否作为模板组件使用
    isTemplateEdit: Boolean, // 是否作为模板编辑组件使用
    templateParams: Object, // 作为模板时保存的参数
    showBillShared: Boolean,
    hiddenKindTabs: {
      type: Array,
      default: () => [],
    },
    defaultDomainId: String,
    defaultProjectId: String,
    defaultExternalProjectName: String,
    defaultTag: Object,
    defaultResourceType: String,
    defaultOriginResType: String,
    defaultProductType: String,
    defaultDate: Object,
    defaultAccountId: String,
    defaultBrand: String,
    defaultDateMode: {
      type: String,
      default: () => 'month',
    },
    defaultDataType: {
      type: String,
      default: () => 'day',
    },
    yearFeeTitleYear: Number || String,
  },
  data () {
    const groupTabOpts = GROUP_TABS.filter(item => {
      const fieldMap = {
        platform: 'brand',
        cloudprovider_name: 'cloudprovider',
        owner_name: 'owner',
        linked_name: 'linked',
        'resource-type': 'resource_type',
        'origin-res-type': 'origin_res_type',
        'charge-type': 'charge_type',
        'project-type': 'project_type',
        external_project: 'external_project_name',
      }
      const field = fieldMap[item.key] || item.key
      return !this.hiddenKindTabs.includes(item.key) && !this.$isScopedPolicyMenuHidden(`fee_hidden_items.${field}`)
    }).map(item => {
      if (item.t) item.title = this.$t(item.t)
      if (item.l) item.label = this.$t(item.l)
      return item
    })
    return {
      colors: ['#ADD1F3', '#F3CBAD', '#F3ADB2', '#ADE4B6', '#ADAEF3', '#A593E0', '#7f9eb2', '#f6ea8c', '#a5dff9', '#77AAAD', '#E71D36', '#4ea1d3'],
      dateTime: this.defaultDate || {},
      dateMode: this.defaultDateMode,
      dataType: this.defaultDataType,
      balance: {},
      envParams: {},
      categoryArr: [],
      predictDataList: [],
      predictSeriesArr: [],
      trendDataList: [],
      pieDataList: [],
      hiddenLegends: [],
      showAlert: true,
      costHeader: {
        title: this.$t('bill.text_98'),
      },
      loading: false,
      costBtns: [
        {
          key: 'month',
          label: this.$t('bill.text_50'),
        },
        {
          key: 'last_month',
          label: this.$t('bill.text_51'),
        },
        {
          key: 'year',
          label: this.$t('bill.text_99'),
        },
      ],
      groupTab: this.templateParams?.group_tab || groupTabOpts[0]?.key,
      groupTabOpts,
      resType: null,
      domainId: this.defaultDomainId || this.templateParams?.domain_id || null,
      domainSelected: {},
      tagKey: this.templateParams?.tag_key || null,
      instanceTagKey: this.templateParams?.instance_tag_key || null,
      projectTagKey: this.templateParams?.project_tag_key || null,
      dimensionId: null,
      dimensionSelected: {},
      GROUP_TABS_MAP: arrayToObj(groupTabOpts, 'key'),
      domain: {},
      currentBillShared: this.$store.state.bill?.billShared,
      currentProjectShared: this.$store.state.bill?.projectShared,
      currentCurrency: this.$store.state.common?.bill?.currency,
    }
  },
  computed: {
    ...mapGetters(['l3PermissionEnable']),
    ...mapState('common', {
      billConfig: state => state.bill.globalConfig,
    }),
    billShared () {
      if (this.isTemplate) {
        if (this.templateParams && this.templateParams.hasOwnProperty('bill_shared')) {
          return this.templateParams.bill_shared
        }
      }
      return this.$store.state.bill?.billShared
    },
    projectShared () {
      if (this.isTemplate) {
        if (this.templateParams && this.templateParams.hasOwnProperty('project_shared')) {
          return this.templateParams.project_shared
        }
      }
      return this.$store.state.bill?.projectShared
    },
    showOverview () {
      return true
    },
    currency () {
      if (this.isTemplate) {
        if (this.templateParams && this.templateParams.hasOwnProperty('currency')) {
          return this.templateParams.currency
        }
      }
      return this.currentCurrency
    },
    showPredict () {
      return this.billConfig.enable_prediction
    },
    moneyCardTitle () {
      return this.$te(`bill.${this.dateMode}_fee`) ? this.$t(`bill.${this.dateMode}_fee`) : this.$t('bill.text_309')
    },
    calcTrendDataList () {
      const list = this.trendDataList.map(item => {
        const ret = { ...item }
        if (this.groupTab === 'cloudprovider') {
          const targets = this.pieTop10.filter(str => str.replace(/\(([^()]+)\)(?=[^()]*$)/, '') === item.name)
          if (targets.length) {
            ret.name = targets[0]
          }
        }
        return ret
      })
      return list
    },
    defaultTime () {
      const ret = { start: this.$moment(), end: this.$moment().startOf('month') }
      const { start_date, end_date } = this.defaultDate || {}
      if (start_date && end_date) {
        ret.start = this.$moment(start_date.replace('TZ', ''))
        ret.end = this.$moment(end_date.replace('TZ', ''))
      }
      return ret
    },
    yearFeeTitle () {
      if (this.yearFeeTitleYear) {
        return this.$t('bill.some_year_fee', [this.yearFeeTitleYear])
      }
      return this.$t('bill.some_year_fee', [this.$moment().format('YYYY')])
    },
    dateStyle () {
      if (this.defaultDate?.month) {
        return { height: '32px' }
      }
      return ''
    },
    resTypeParams () {
      const currency = this.$store.state.common?.bill?.currency.replace('_', '').replace('*', '')
      const param = {
        query_type: 'resource_type',
        admin: this.$store.getters.isAdminMode,
        currency,
      }

      if (this.defaultResourceType) {
        param.resource_type = this.defaultResourceType
      }
      if (this.defaultOriginResType) {
        param.origin_res_type = this.defaultOriginResType
      }
      if (this.defaultProductType) {
        param.product_type = this.defaultProductType
      }
      if (this.defaultDomainId) {
        param.domain_id = this.defaultDomainId
      }
      if (this.defaultProjectId) {
        param.tenant_id = this.defaultProjectId
      }
      if (this.defaultExternalProjectName) {
        param.external_project_name = this.defaultExternalProjectName
      }
      if (this.defaultAccountId) {
        param.account_id = this.defaultAccountId
      }
      if (this.defaultBrand) {
        param.brand = this.defaultBrand
      }
      if (this.dateTime.start_date) {
        param.start_day = this.$moment(this.dateTime.start_date.replace('TZ', '')).format('YYYYMMDD')
        param.end_day = this.$moment(this.dateTime.end_date.replace('TZ', '')).format('YYYYMMDD')
      }
      return param
    },
    domainParams () {
      const param = { query_type: 'domain', admin: this.$store.getters.isAdminMode }
      if (this.defaultDomainId) {
        param.domain_id = this.defaultDomainId
      }
      if (this.defaultAccountId) {
        param.account_id = this.defaultAccountId
      }
      if (this.defaultBrand) {
        param.brand = this.defaultBrand
      }
      if (this.dateTime.start_date) {
        param.start_day = this.$moment(this.dateTime.start_date.replace('TZ', '')).format('YYYYMMDD')
        param.end_day = this.$moment(this.dateTime.end_date.replace('TZ', '')).format('YYYYMMDD')
      }
      return param
    },
    tagParams () {
      const params = {
        resources: 'payment_bill',
        key_prefix: ['user:', 'ext:'],
        scope: this.$store.getters.scope,
        key_only: true,
        is_prepaid_amortizing: this.currentBillShared,
        is_project_sharing: this.currentProjectShared,
        ...this.currencyParams,
      }
      if (this.defaultAccountId) {
        params.account_id = this.defaultAccountId
      }
      if (this.defaultBrand) {
        params.brand = this.defaultBrand
      }
      if (this.defaultDomainId) {
        params.domain_id = this.defaultDomainId
      }
      if (this.defaultProjectId) {
        params.project_id = this.defaultProjectId
      }
      if (this.defaultExternalProjectName) {
        params.external_project_name = this.defaultExternalProjectName
      }
      if (this.defaultResourceType) {
        params.resource_type = this.defaultResourceType
      }
      if (this.defaultOriginResType) {
        params.origin_res_type = this.defaultOriginResType
      }
      if (this.defaultProductType) {
        params.product_type = this.defaultProductType
      }
      if (this.dateTime.start_date) {
        params.start_day = this.$moment(this.dateTime.start_date.replace('TZ', '')).format('YYYYMMDD')
        params.end_day = this.$moment(this.dateTime.end_date.replace('TZ', '')).format('YYYYMMDD')
      }
      return params
    },
    instanceTagParams () {
      const params = {
        resources: 'payment_bill',
        key_prefix: ['user:', 'ext:'],
        scope: this.$store.getters.scope,
        key_only: true,
        is_prepaid_amortizing: this.currentBillShared,
        is_project_sharing: this.currentProjectShared,
        ...this.currencyParams,
      }
      if (this.defaultAccountId) {
        params.account_id = this.defaultAccountId
      }
      if (this.defaultBrand) {
        params.brand = this.defaultBrand
      }
      if (this.defaultDomainId) {
        params.domain_id = this.defaultDomainId
      }
      if (this.defaultProjectId) {
        params.project_id = this.defaultProjectId
      }
      if (this.defaultExternalProjectName) {
        params.external_project_name = this.defaultExternalProjectName
      }
      if (this.defaultResourceType) {
        params.resource_type = this.defaultResourceType
      }
      if (this.defaultOriginResType) {
        params.origin_res_type = this.defaultOriginResType
      }
      if (this.defaultProductType) {
        params.product_type = this.defaultProductType
      }
      if (this.dateTime.start_date) {
        params.start_day = this.$moment(this.dateTime.start_date.replace('TZ', '')).format('YYYYMMDD')
        params.end_day = this.$moment(this.dateTime.end_date.replace('TZ', '')).format('YYYYMMDD')
      }
      return params
    },
    projectTagParams () {
      const params = {
        resources: 'payment_bill',
        key_prefix: ['user:', 'ext:'],
        scope: this.$store.getters.scope,
        key_only: true,
        is_prepaid_amortizing: this.currentBillShared,
        is_project_sharing: this.currentProjectShared,
        ...this.currencyParams,
      }
      if (this.defaultAccountId) {
        params.account_id = this.defaultAccountId
      }
      if (this.defaultBrand) {
        params.brand = this.defaultBrand
      }
      if (this.defaultDomainId) {
        params.domain_id = this.defaultDomainId
      }
      if (this.defaultProjectId) {
        params.project_id = this.defaultProjectId
      }
      if (this.defaultExternalProjectName) {
        params.external_project_name = this.defaultExternalProjectName
      }
      if (this.defaultResourceType) {
        params.resource_type = this.defaultResourceType
      }
      if (this.defaultOriginResType) {
        params.origin_res_type = this.defaultOriginResType
      }
      if (this.defaultProductType) {
        params.product_type = this.defaultProductType
      }
      if (this.dateTime.start_date) {
        params.start_day = this.$moment(this.dateTime.start_date.replace('TZ', '')).format('YYYYMMDD')
        params.end_day = this.$moment(this.dateTime.end_date.replace('TZ', '')).format('YYYYMMDD')
      }
      return params
    },
    dimensionParams () {
      return {
        limit: 20,
        scope: this.$store.getters.scope,
      }
    },
    normalParams () {
      const params = {}
      if (this.defaultAccountId) {
        params.account_id = this.defaultAccountId
      }
      if (this.defaultBrand) {
        params.platform_brand = this.defaultBrand
      }
      if (this.defaultDomainId) {
        params.domain_id = this.defaultDomainId
      }
      if (this.defaultProjectId) {
        params.project = this.defaultProjectId
      }
      if (this.defaultExternalProjectName) {
        params.external_project_name = this.defaultExternalProjectName
      }
      if (this.defaultTag) {
        params['tags.0.key'] = this.defaultTag.key
        params['tags.0.value'] = this.defaultTag.value
      }
      if (this.defaultResourceType) {
        params.resource_type = this.defaultResourceType
      }
      if (this.defaultOriginResType) {
        params.origin_res_type = this.defaultOriginResType
      }
      if (this.defaultProductType) {
        params.product_type = this.defaultProductType
      }
      params.is_prepaid_amortizing = !!this.currentBillShared
      params.is_project_sharing = !!this.currentProjectShared
      if (this.isTemplate) {
        params.$t = uuid()
      }
      return params
    },
    pieParams () {
      const { start_date, end_date, data_type } = (this.dateTime || this.defaultDate)
      const params = {
        start_date,
        end_date,
        data_type,
        scope: this.$store.getters.scope,
        ...this.envParams,
        ...R.clone(this.currencyParams),
        ...this.normalParams,
      }
      // 选择条件
      if (this.groupTab === 'resource' && this.resType && this.resType !== 'all') {
        params.resource_type = this.resType
      }
      if (this.groupTab === 'project' && this.domainId && this.domainId !== 'all') {
        params.domain_id = this.domainId
      }
      if (this.groupTab === 'tag' && this.tagKey) {
        params['tags.0.key'] = this.tagKey
      }
      if (this.groupTab === 'instance_tag' && this.instanceTagKey) {
        params['instancetags.0.key'] = this.instanceTagKey
      }
      if (this.groupTab === 'project_tag' && this.projectTagKey) {
        params['project_tags.0.0.key'] = this.projectTagKey
      }
      if (this.groupTab === 'dimension' && this.dimensionId) {
        params.dimension_id = this.dimensionId
        params.dimension_type = this.dimensionSelected?.dimension_type
      }
      return params
    },
    isTop10 () {
      return ['resource', 'account', 'cloudprovider', 'project'].includes(this.groupTab)
    },
    pieListTitle () {
      return this.GROUP_TABS_MAP[this.groupTab]?.title
    },
    queryType () {
      return this.GROUP_TABS_MAP[this.groupTab]?.queryType
    },
    pieTop10 () {
      return this.pieDataList.map(item => item.origin_item_name).slice(0, 10)
    },
  },
  watch: {
    dateTime (val) {
      this.fetchData()
      this.$bus.$emit('date-time-change', val)
    },
    cloudEnv (val) {
      switch (val) {
        case 'onpremise':
          this.envParams = { is_on_premise: true }
          this.showAlert = false
          break
        case 'private':
          this.envParams = { private_cloud: true }
          this.showAlert = false
          break
        case 'public':
          this.envParams = { public_cloud: true }
          this.showAlert = false
          break
        default:
          this.showAlert = true
          this.envParams = {}
      }
      this.fetchData()
    },
    billShared (val) {
      this.currentBillShared = val
    },
    projectShared (val) {
      this.currentProjectShared = val
    },
    currentBillShared (val) {
      this.fetchData()
    },
    currentProjectShared (val) {
      this.fetchData()
    },
    groupTab (val) {
      this.initFilterParams()
      this.fetchData(true)
    },
    tagKey (val) {
      this.fetchData(true)
    },
    instanceTagKey (val) {
      this.fetchData(true)
    },
    projectTagKey (val) {
      this.fetchData(true)
    },
    domainId (val) {
      this.fetchData(true)
    },
    dimensionId (val) {
      this.fetchData(true)
    },
    resType (val) {
      this.fetchData(true)
    },
    globalCurrency (val) {
      this.currentCurrency = val
    },
  },
  created () {
    this.balanceM = new this.$Manager('bill_balances', 'v1')
    this.analysisM = new this.$Manager('bill_analysises', 'v1')
    this.analysispredictM = new this.$Manager('analysispredicts', 'v1')
    if (this.defaultDate || this.isTemplate) {
      this.fetchData()
    }
  },
  methods: {
    changeCurrency (val) {
      this.currentCurrency = val
    },
    legendselectchanged (selected) {
      const keys = Object.keys(selected)
      const hiddenLegends = []
      keys.map(key => {
        if (!selected[key]) {
          hiddenLegends.push(key)
        }
      })
      this.hiddenLegends = hiddenLegends
    },
    domainUpdate (domain) {
      this.domain = domain
    },
    initFilterParams () {
      this.domainId = null
      this.dimensionId = null
      this.tagKey = null
      this.projectTagKey = null
      this.resType = null
      this.dimensionSelected = {}
      this.topLimit = 10
    },
    async fetchData (ignoreBalance) {
      if (!ignoreBalance) {
        this.getBalance()
      }
      // 饼图失败不阻断趋势请求
      try {
        await this.fetchPieData()
      } catch (e) {
        this.pieDataList = []
      }
      this.getData()
    },
    asArray (val) {
      return Array.isArray(val) ? val : []
    },
    isValidSeries (series) {
      return !!(series && Array.isArray(series.data))
    },
    async getBalance () {
      const { start_date, end_date } = this.dateTime
      try {
        const params = {
          ...this.envParams,
          admin: this.$store.getters.isAdminMode,
          scope: this.$store.getters.scope,
          account: 'billOverview',
          start_date,
          end_date,
          ...this.currencyParams,
          is_customize_time: true,
          ...this.normalParams,
        }
        if (this.defaultDate) {
          const { month } = this.defaultDate
          if (month) {
            params.month = Number(month)
          }
        }
        const { data } = await this.balanceM.get({
          id: 'billOverview',
          params: this.transformParams('balance', params),
        })
        const { year_fee, month_fee, last_month_fee } = data
        let ring_radio = 0
        if (Number(last_month_fee) !== 0) {
          ring_radio = (Number(month_fee) - Number(last_month_fee)) / Math.abs(Number(last_month_fee))
        }
        this.balance = Object.assign({}, this.balance, { year_fee, month_fee, increase: ring_radio })
      } catch (error) {
        throw error
      }
    },
    /** 拉取预测序列；失败返回 null（视为已完成，不阻断趋势图） */
    async buildPredictionSeries (params) {
      const predictParams = {
        ...params,
        'group.0': params.data_type,
        data_type: undefined,
      }

      if (!(this.dateMode === 'month' || this.dateMode === 'last_month' || this.dateMode === 'year' || this.dateMode === 'custom')) {
        return null
      }
      const predictRes = await new this.$Manager('predictions').get({ id: 'query', params: predictParams })
      const rawList = this.asArray(predictRes?.data?.data)
      if (rawList.length === 0) {
        return null
      }
      let predictDataList = []
      if (this.dateMode === 'month') {
        const currentDate = new Date().getDate()
        predictDataList = rawList.map((item, idx) => {
          return idx < currentDate - 1 ? '' : item?.prediction
        })
      }
      if (this.dateMode === 'last_month') {
        // 上个月已经完整，不显示预测数据
        predictDataList = rawList.map(() => '')
      }
      if (this.dateMode === 'year') {
        const currentMonth = new Date().getMonth() + 1
        predictDataList = rawList.map((item, idx) => {
          return idx < currentMonth ? '' : item?.prediction
        })
      }
      if (this.dateMode === 'custom') {
        if (this.dataType === 'day') {
          const currentDate = this.$moment().format('YYYYMMDD')
          predictDataList = rawList.map((item) => {
            return item?.day <= currentDate ? '' : item?.prediction
          })
        } else if (this.dataType === 'month') {
          const currentMonth = this.$moment().format('YYYYMM')
          predictDataList = rawList.map((item) => {
            return item?.month <= currentMonth ? '' : item?.prediction
          })
        }
      }
      return {
        name: this.$t('bill.predict'),
        isPredict: true,
        data: predictDataList,
      }
    },
    async getData () {
      // eslint-disable-next-line camelcase
      const { start_date, end_date, data_type } = this.dateTime
      this.categoryArr = []
      this.predictSeriesArr = []
      this.loading = true
      try {
        const params = {
          query_type: 'expense_trend',
          start_date,
          end_date,
          data_type,
          admin: this.$store.getters.isAdminMode,
          scope: this.$store.getters.scope,
          ...this.envParams,
          ...this.currencyParams,
          ...this.normalParams,
        }
        const billAnalysisesParams = {
          ...params,
          group: this.GROUP_TABS_MAP[this.groupTab]?.trendGroup,
        }

        if (this.groupTab === 'tag') {
          if (this.tagKey) {
            billAnalysisesParams.group = `tag:${this.tagKey}`
          } else {
            return
          }
        }
        if (this.groupTab === 'project_tag') {
          if (this.projectTagKey) {
            billAnalysisesParams.group = `project_tag:${this.projectTagKey}`
          } else {
            return
          }
        }
        if (this.groupTab === 'instance_tag') {
          if (this.instanceTagKey) {
            billAnalysisesParams.group = `instance_tag:${this.instanceTagKey}`
          } else {
            return
          }
        }
        const resp = await this.analysisM.list({ params: billAnalysisesParams })
        const data = this.asArray(resp?.data?.data)
        if (data.length === 0) {
          return
        }
        const firstTrendData = this.asArray(data[0]?.data)
        if (firstTrendData.length === 0) return
        this.categoryArr = firstTrendData.map(v => ({ time: v?.stat_date }))
        const isTagGroup = ['tag', 'instance_tag', 'project_tag'].includes(this.groupTab)
        const predictDataMap = {}
        data.forEach(item => {
          if (!item) return
          // const name = this.groupTab === 'cloudprovider' ? `${item.name} (${(item.id || '').substring(0, 6)})` : item.name
          let name = item.name
          if (this.groupTab === 'cloudprovider') {
            const len = data.filter(l => l && l.name === item.name).length
            if (len > 1) {
              name = `${item.name} (${(item.id || '').substring(0, 6)})`
            }
          }
          if (name == null || name === '') return
          const itemData = this.asArray(item.data)
          const series = {
            name: name,
            isStackAd: true,
            data: itemData.map((v, idx) => {
              let stat_value = v?.stat_value
              if (this.showPredict) {
                if (this.dateMode === 'month') {
                  const currentDate = new Date().getDate()
                  stat_value = idx >= currentDate - 1 ? '' : v?.stat_value
                }
                if (this.dateMode === 'last_month') {
                  // 上个月已经完整，不显示预测数据
                  stat_value = ''
                }
                if (this.dateMode === 'year') {
                  const currentMonth = new Date().getMonth() + 1
                  stat_value = idx >= currentMonth ? '' : v?.stat_value
                }
              }
              return stat_value
            }),
          }
          this.getPredictMatchKeys(name, isTagGroup).forEach(key => {
            if (!predictDataMap[key]) {
              predictDataMap[key] = series
            }
          })
        })
        const pieList = this.asArray(this.pieDataList)
        const pieTop10DataList = pieList.slice(0, 10)
        const pieOtherDataList = pieList.slice(10)
        const predictSeriesArr = pieTop10DataList.map(item => {
          if (!item) return null
          const origin_item_name = this.groupTab === 'cloudprovider' ? item.name : item.origin_item_name
          const nameIdFix = this.groupTab === 'cloudprovider' ? `${item.name} (${(item.id || '').substring(0, 6)})` : item.origin_item_name
          return this.resolvePredictSeries(predictDataMap, origin_item_name, isTagGroup) ||
            this.resolvePredictSeries(predictDataMap, nameIdFix, isTagGroup)
        }).filter(item => this.isValidSeries(item))
        const predictOtherSeriesArr = pieOtherDataList.map(item => {
          if (!item) return null
          return this.resolvePredictSeries(predictDataMap, item.origin_item_name, isTagGroup)
        }).filter(item => this.isValidSeries(item))
        const othersData = []
        if (predictOtherSeriesArr.length > 0) {
          const dataLen = this.asArray(predictOtherSeriesArr[0].data).length
          for (let idx = 0; idx < dataLen; idx++) {
            let sum_value = 0
            predictOtherSeriesArr.forEach(o => {
              sum_value += +(this.asArray(o.data)[idx] || 0)
            })
            othersData.push(sum_value)
          }
          predictSeriesArr.push({
            name: this.$t('bill.other'),
            isOther: true,
            data: othersData,
          })
        }
        // 等趋势 + 预测都结束后再一次性赋值，避免图渲染两次
        if (this.showPredict) {
          try {
            const predictLine = await this.buildPredictionSeries(params)
            if (this.isValidSeries(predictLine)) {
              predictSeriesArr.push(predictLine)
            }
          } catch (e) {
            // 预测失败也视为完成，仅展示趋势
          }
        }
        this.predictSeriesArr = predictSeriesArr
      } catch (error) {
        this.categoryArr = []
        this.predictSeriesArr = []
      } finally {
        this.loading = false
      }
    },
    mapperResData (list) {
      return [{ id: 'all', item_id: 'all', item_name: this.$t('bill.text_259') }, ...(this.asArray(list).map(v => {
        return {
          ...v,
          item_name: getBillResourceTypeLabel(v.item_id),
        }
      }))]
    },
    domainMapper (list) {
      return [{ id: 'all', item_id: 'all', item_name: this.$t('bill.text_259') }, ...this.asArray(list)]
    },
    tagMapper (list) {
      const maps = {}
      this.asArray(list).forEach(item => {
        if (!item?.key) return
        if (item.key.startsWith('ext:') || item.key.startsWith('user:')) {
          const key = item.key.startsWith('user:') ? item.key.replace('user:', '') : item.key
          maps[item.key] = {
            name: key,
            id: item.key,
          }
        }
      })
      const ret = Object.values(maps)
      // ret.sort((a, b) => mixSortFunc(a.name.toLowerCase(), b.name.toLowerCase()))
      return ret
    },
    dimensionMapper (list) {
      return this.asArray(list).filter(item => item && item.enabled)
    },
    setDayWarning () {
      this.createDialog('SetMoneyWarningDialog', {
        title: this.$t('bill.text_94'),
        enable: false,
        currencyCn: this.currencyCn,
        fetchDataParams: {
          type: 'resFee',
          detail: true,
          overview: true,
          project_id: this.$store.getters.userInfo.projectId,
          scope: this.$store.getters.scope,
          ...this.envParams,
        },
      })
    },
    setMonthWarning () {
      this.createDialog('SetMoneyWarningDialog', {
        title: this.$t('bill.text_96'),
        enable: false,
        currencyCn: this.currencyCn,
        fetchDataParams: {
          type: 'monthFee',
          detail: true,
          overview: true,
          project_id: this.$store.getters.userInfo.projectId,
          scope: this.$store.getters.scope,
          ...this.envParams,
        },
      })
    },
    getDate () {
      const end = this.$moment()
      const start = this.$moment().startOf('month')
      const ret = {
        start_date: start.format('YYYY-MM-DD') + 'TZ',
        end_date: end.format('YYYY-MM-DD') + 'TZ',
        data_type: TIME_SIZE.month,
      }
      if (this.defaultDate) {
        const { start_date, end_date } = this.defaultDate
        ret.start_date = start_date
        ret.end_date = end_date
        ret.data_type = this.defaultDateMode
      }
      return ret
    },
    goAnalysis () {
      // 上月同期
      const start_date = this.$moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
      const end_date = this.$moment().subtract(1, 'day').subtract(1, 'month').format('YYYY-MM-DD')
      this.$router.push({
        path: '/billanalysis',
        query: {
          start_date,
          end_date,
          group: this.GROUP_TABS_MAP[this.groupTab].trendGroup,
          domain_id: this.groupTab === 'project' && this.domainId && this.domainId !== 'all' && this.domainId === this.domain.item_id ? this.domain.item_name : null,
          tag_key: this.groupTab === 'tag' && this.tagKey ? this.tagKey : null,
          instance_tag_key: this.groupTab === 'instance_tag' && this.instanceTagKey ? this.instanceTagKey : null,
          project_tag_key: this.groupTab === 'project_tag' && this.projectTagKey ? this.projectTagKey : null,
        },
      })
    },
    dimensionChange (val) {
      this.dimensionSelected = val
    },
    getTabLabel () {
      let name = this.$t('bill.text_88')
      this.tabs.map(item => {
        if (item.key === this.groupTab) {
          name = item.label
        }
      })
      return name
    },
    /** 名称对齐候选 key；标签额外兼容 key=value / 去前缀 */
    getPredictMatchKeys (name, isTagGroup = false) {
      if (name == null || name === '') return []
      const str = String(name)
      const keys = [str]
      if (isTagGroup) {
        const eqIdx = str.indexOf('=')
        if (eqIdx >= 0) {
          keys.push(str.slice(eqIdx + 1))
        }
        keys.push(str.replace(/^user:/, '').replace(/^ext:/, ''))
      }
      return [...new Set(keys.filter(k => k !== ''))]
    },
    resolvePredictSeries (predictDataMap = {}, rawName, isTagGroup = false) {
      const keys = this.getPredictMatchKeys(rawName, isTagGroup)
      for (let i = 0; i < keys.length; i++) {
        const series = predictDataMap[keys[i]]
        if (this.isValidSeries(series)) return series
      }
      return null
    },
    getNameI18n (name, type, ignoreTagKey = true) {
      if (name == null || name === '') return ''
      const groupTab = type || this.groupTab
      if (groupTab === 'platform') {
        return getBrandName(name)
      } else if (groupTab === 'resource-type') {
        return getBillResourceTypeLabel(name)
      } else if (groupTab === 'charge-type') {
        return this.$te(`billingType.${name}`) ? this.$t(`billingType.${name}`) : name
      } else if (groupTab === 'tag' || groupTab === 'instance_tag' || groupTab === 'project_tag') {
        if (ignoreTagKey) {
          const tagArr = String(name).split('=')
          const tag = tagArr?.length > 1 ? tagArr[1] : tagArr[0]
          return String(tag || '').replace('___no_value__', this.$t('common_736'))
        }
        return String(name).replace('user:', '').replace('___no_value__', this.$t('common_736'))
      } else if (groupTab === 'project-type') {
        return this.$te(`projectType.${name}`) ? this.$t(`projectType.${name}`) : name
      }
      return name
    },
    getProvider (name) {
      if (!name) return ''
      const providerObj = PROVIDER_MAP[String(name).toLowerCase()]
      if (providerObj) {
        return providerObj.label
      }
      return name
    },
    getResName (name) {
      return getBillResourceTypeLabel(name)
    },
    genParams () {
      // eslint-disable-next-line camelcase
      const params = {
        $t: +new Date(),
        scope: this.$store.getters.scope,
        query_type: this.queryType,
        ...this.pieParams,
      }
      if (this.$store.getters.isAdminMode) {
        params.admin = true
      }
      if (this.isTop10) {
        params.limit = this.topLimit
      }
      if (this.groupTab === 'tag') {
        if (!params['tags.0.key']) return
      }
      if (this.queryType === 'customize_dimension') {
        if (!params.dimension_id) return
      }
      return params
    },
    async fetchPieData () {
      const params = this.genParams()
      if (!params || !params.start_date || !params.query_type) {
        this.pieDataList = []
        return
      }
      try {
        let data
        if (this.queryType === 'tag_stat') {
          if (this.defaultTag) {
            params.tag_key = this.defaultTag.key
            params.tag_value = this.defaultTag.value
            delete params['tags.0.key']
            delete params['tags.0.value']
          }
          const resp = await this.analysisM.get({ id: 'tags', params: params })
          data = resp?.data
        } else {
          const resp = await this.analysisM.list({ params })
          data = resp?.data?.data
        }
        data = this.asArray(data)
        if (data.length === 0) {
          this.pieDataList = []
          return
        }
        const originData = R.clone(data)
        data = data.filter(Boolean).map(val => {
          const ret = {
            ...val,
            item_name: this.getNameI18n(val.item_name || val.res_name, '', true),
            origin_item_name: val.item_name || '',
          }
          if (this.queryType === 'cloudprovider_expense') {
            const item_name = val.name || val.item_name || val.res_name
            const len = originData.filter(l => l && (l.name || l.item_name || l.res_name) === item_name).length
            if (len > 1) {
              ret.item_name = this.getNameI18n(val.name || val.item_name || val.res_name, '', true) + ` (${(val.id || '').substring(0, 6)})`
              ret.origin_item_name = (val.name || val.item_name || '') + ` (${(val.id || '').substring(0, 6)})`
            } else {
              ret.item_name = this.getNameI18n(val.name || val.item_name || val.res_name, '', true)
              ret.origin_item_name = val.name || val.item_name || ''
            }
          }
          return ret
        })
        data.sort((a, b) => (b?.res_fee || 0) - (a?.res_fee || 0))
        this.pieDataList = data
      } catch (error) {
        this.pieDataList = []
      }
    },
    topLimitChange (limit) {
      this.topLimit = limit
      this.fetchData()
    },
    exportExcel () {
      const filename = `${this.$t('bill.text_36')}.xlsx`
      const wb = XLSX.utils.book_new()
      // 总览
      if (this.showOverview) {
        const data = [
          [this.moneyCardTitle, this.yearFeeTitle],
          [`${this.currencySign} ${this.balance.month_fee}`, `${this.currencySign} ${this.balance.year_fee}`],
        ]
        const ws_name = this.$t('bill.text_36')
        const ws = addDataToSheetAfterFormat({ data })
        XLSX.utils.book_append_sheet(wb, ws, ws_name)
      }

      // 预测 消费趋势
      const dateList = this.asArray(this.categoryArr).map(item => String(item?.time || '').replace('TZ', ''))
      const predictData = [
        ['', ...dateList],
      ]
      this.asArray(this.predictSeriesArr).forEach(item => {
        if (!this.isValidSeries(item)) return
        const list = [this.getNameI18n(item.name)]
        this.asArray(item.data).forEach(val => {
          list.push(`${this.currencySign} ${numerify(val || 0, '0,0.00')}`)
        })
        predictData.push(list)
      })
      const predict_ws_name = this.showPredict ? this.$t('bill.predict') : this.costHeader.title
      const predict_ws = addDataToSheetAfterFormat({ data: predictData })
      XLSX.utils.book_append_sheet(wb, predict_ws, predict_ws_name)

      // 费用占比
      const groupMeta = this.GROUP_TABS_MAP[this.groupTab] || {}
      const data = [
        [groupMeta.label || '', this.$t('bill.text_35'), this.$t('bill.text_317')],
      ]
      const pieList = this.asArray(this.pieDataList).filter(Boolean)
      let total = 0
      pieList.forEach(item => {
        total += item.res_fee || 0
      })
      pieList.forEach(item => {
        const percent = !total || item.res_fee / total < 0.00005 ? 0 : item.res_fee / total
        const list = [item.item_name, `${this.currencySign} ${numerify(item.res_fee || 0, '0,0.00')}`, `${numerify(percent * 100, '0.00')}%`]
        data.push(list)
      })
      const ws_name = groupMeta.title || this.$t('bill.text_35')
      const ws = addDataToSheetAfterFormat({ data })
      XLSX.utils.book_append_sheet(wb, ws, ws_name)
      XLSX.writeFile(wb, filename)
    },
    exportPdf () {
      getPdf({
        title: this.$t('bill.text_36'),
        target: '#overview-target',
      })
    },
    // 作为模板时转换参数
    transformParams (type, params) {
      // if (this.isTemplate && this.templateParams) {
      //   console.log('paraams', params)
      //   console.log('templageParams', this.templa)
      // }
      return params
    },
    // 导出作为报表模板时参数
    getTemplateParams () {
      const params = {
        group_tab: this.groupTab,
        bill_shared: this.billShared,
        project_shared: this.projectShared,
        currency: this.currency,
        currencyParams: this.currencyParams,
      }
      if (this.groupTab === 'tag') {
        params.tag_key = this.tagKey
      }
      if (this.groupTab === 'instance_tag') {
        params.instance_tag_key = this.instanceTagKey
      }
      if (this.groupTab === 'project_tag') {
        params.project_tag_key = this.projectTagKey
      }
      if (this.groupTab === 'project') {
        params.domain_id = this.domainId
      }
      return params
    },
  },
}
</script>
